import React, { useRef, useState } from 'react';
import { Button, Input, Alert, Form } from '@intech/web-ui';

import { Subtitle } from '../styles';

import logo from '../../../assets/logo.png';
import { FaShareSquare, FaArrowLeft } from 'react-icons/fa';
import { UsuarioService } from '../../../services';
import { LoginEntidade } from '../../../entidades';
import { useHistory } from 'react-router-dom';
import { BaseAuth } from '../Base';
import { CheckboxContainer, CheckboxTitle } from './styles';
import { Checkbox } from './Checkbox';
import { DMN_ORIGEM_SISTEMA } from '@domains';

export const EsqueciSenha: React.FC = () => {
  const history = useHistory();
  const form = useRef<Form>(null);

  const [cpf, setCpf] = useState<string>('');
  const [bday, setBday] = useState<string>('');
  const [enviarEmail, setEnviarEmail] = useState(true);
  const [enviarSms, setEnviarSms] = useState(false);
  const [AlertText, setAlertText] = useState<string>("");

  async function SendNewPassword() {
    try {
      setAlertText("");
      if (form.current?.validate()) {
        if (cpf.length < 11) {
          setAlertText("Campo \"CPF\" inválido.");
          return;
        }

        const user = new LoginEntidade();
        user.Cpf = cpf;
        user.DataNascimento = bday;
        user.Origem = DMN_ORIGEM_SISTEMA.PORTAL;

        var resultado = await UsuarioService.CriarAcessoV2(user, enviarEmail, enviarSms);
        window.alert(resultado);
        console.log(resultado);
        history.push("login");
      }
    }
    catch (e) {
      const error = e.response ? e.response.data : e;
      console.log(error);
      setAlertText(error);
    }
  }

  function toggleSms() {
    setEnviarSms(true);
    setEnviarEmail(false);
  }

  function toggleEmail() {
    setEnviarSms(false);
    setEnviarEmail(true);
  }

  return (
    <BaseAuth>

      <Subtitle>
        <b>
          {"Esqueci minha senha / Primeiro Acesso"}
        </b>

        <br />
        <br />

        <small>
          {"Preencha as informações para que possamos gerar uma senha que será enviada para seu e-mail cadastrado na Faelce."}
        </small>
      </Subtitle>

      <Form ref={form}>
        <Input
          value={cpf}
          onChange={setCpf}
          placeholder={"CPF (somente números)"}
        />

        <Input
          value={bday}
          onChange={setBday}
          placeholder={"Data de Nascimento"}
          type={"date"}
        />

        <CheckboxTitle>Enviar nova senha por:</CheckboxTitle>
        <CheckboxContainer>
          <Checkbox
            title={"E-mail"}
            active={enviarEmail}
            onClick={toggleEmail}
          />
          <Checkbox
            title={"SMS"}
            active={enviarSms}
            onClick={toggleSms}
          />
        </CheckboxContainer>

        <Button
          icon={<FaShareSquare />}
          onClick={SendNewPassword}
          type="primary"
          title={"Enviar Nova Senha"}
          loadingText={"Enviando..."}
          usesLoading
          block
        />

        <Button
          icon={<FaArrowLeft />}
          onClick={() => history.push('login')}
          type={"light"}
          title={"Voltar para o login"}
          block
        />

        <Alert type={"danger"} formAlert />

        {AlertText !== "" && <Alert type={"danger"}>
          {AlertText}
        </Alert>}
      </Form>

    </BaseAuth>
  );
}